/**
 * Copyright (c) 2000-present Liferay, Inc. All rights reserved.
 *
 * This library is free software; you can redistribute it and/or modify it under
 * the terms of the GNU Lesser General Public License as published by the Free
 * Software Foundation; either version 2.1 of the License, or (at your option)
 * any later version.
 *
 * This library is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the GNU Lesser General Public License for more
 * details.
 */

import toggleDisabled from './toggle_disabled';

export default function removeEntitySelection(
	entityIdString,
	entityNameString,
	removeEntityButton,
	namespace
) {
	const elementByEntityId = document.getElementById(
		`${namespace}${entityIdString}`
	);

	if (elementByEntityId) {
		elementByEntityId.value = 0;
	}

	const elementByEntityName = document.getElementById(
		`${namespace}${entityNameString}`
	);

	if (elementByEntityName) {
		elementByEntityName.value = '';
	}

	toggleDisabled(removeEntityButton, true);

	Liferay.fire('entitySelectionRemoved');
}
